export function searchInText(searchString: string, targetText: string) {
	return targetText.toLowerCase().includes(searchString.toLowerCase())
}
